import React from 'react'
import { WARFISH_CLASSICS_TAG } from './warfish/presentation'
import { Text, View, type ViewStyle } from 'react-native'

export function MapTag({ variant, testID, style }: {
  variant: 'new' | 'warfish'; testID?: string; style?: ViewStyle
}) {
  const label = variant === 'new' ? 'New' : WARFISH_CLASSICS_TAG
  return <View testID={testID} accessibilityLabel={`${label} map`} className="bg-blood rounded px-1"
    style={[{ alignSelf: 'center', flexShrink: 0 }, variant === 'warfish' && { maxWidth: '100%' }, style]}>
    <Text className="font-stencil text-white" style={{ fontSize: 9, letterSpacing: 0.6 }}>{label.toUpperCase()}</Text>
  </View>
}
